module.exports = __webpack_public_path__ + "static/media/education.f87cdaf1.webp";